import { useTooltipContext } from "./context.js";
import { createContextPart } from "../create-context-part.js";
//#region src/ui/tooltip/arrow.tsx
/** Decorative arrow pointing from the tooltip toward the trigger. Hidden from assistive technology. */
const TooltipArrow = createContextPart({
	displayName: "TooltipArrow",
	tag: "div",
	useContext: useTooltipContext,
	staticProps: { "aria-hidden": "true" }
});
//#endregion
export { TooltipArrow };

//# sourceMappingURL=arrow.js.map